import { createAuthClient } from "better-auth/react"
import { adminClient, apiKeyClient } from "better-auth/client/plugins"

// Determine base URL for API calls from client
// Use NEXT_PUBLIC_BASE_URL if available, otherwise fallback to relative path
const baseURL = process.env.NEXT_PUBLIC_BASE_URL || ''

export const authClient = createAuthClient({
    plugins: [
        adminClient(),
        apiKeyClient()
    ]
})

// Export specific functions for use in components
export const { 
    signIn, 
    signOut, 
    useSession, 
    getSession,
    listSessions,
    revokeSession,
    revokeOtherSessions,
    revokeSessions
} = authClient

// Export admin functions separately
export const { impersonateUser, stopImpersonating } = authClient.admin

// Export apiKey functions separately if preferred
export const apiKeyActions = authClient.apiKey